/**
 * @licence https://gist.github.com/joduplessis/7b3b4340353760e945f972a69e855d11
 */

export const getCookie = (name: string): string | null => {
	const nameLenPlus = name.length + 1

	return (
		document.cookie
			.split(';')
			.map((c) => c.trim())
			.filter((cookie) => cookie.substring(0, nameLenPlus) === `${name}=`)
			.map((cookie) => decodeURIComponent(cookie.substring(nameLenPlus)))[0] || null
	)
}
export const setCookie = (name: string, val: string) => {
	const date = new Date()
	const value = val

	date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
	document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`
}

export const deleteCookie = (name: string) => {
	const date = new Date()
	date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000)
	document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`
}
